import type { Suggestion } from '~/components/SearchSuggest/types';

import { v4 as uuidv4 } from 'uuid';

interface UseResearchsSuggest {
	filteredLastResearchs: ComputedRef<Suggestion[]>;
	updateResearchs: (newResearch: Suggestion) => void;
	removeResearchs: (research: Suggestion) => void;
}

export function useResearchsSuggest(): UseResearchsSuggest {
	const lastResearchs = useCookie<Suggestion[]>('search-suggest', {
		default: () => [],
		sameSite: 'lax',
		expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 30) // 30 days
	});

	const filteredLastResearchs = computed<Suggestion[]>(() =>
		lastResearchs.value.slice(0, 3)
	);

	function updateResearchs(newResearch: Suggestion) {
		const isDuplicate = lastResearchs.value.some(
			existingResearch =>
				JSON.stringify(existingResearch.result) ===
				JSON.stringify(newResearch.result)
		);

		if (isDuplicate) {
			return;
		}

		const research = {
			...newResearch,
			id: uuidv4(),
			type: 'research' as const
		};

		const updatedResearchs = [research, ...lastResearchs.value];

		lastResearchs.value = updatedResearchs.slice(0, 3);
	}

	function removeResearchs(research: Suggestion) {
		lastResearchs.value = lastResearchs.value.filter(
			lastSearch => lastSearch.id !== research.id
		);
	}

	return {
		filteredLastResearchs,
		updateResearchs,
		removeResearchs
	};
}
